module.exports = __webpack_public_path__ + "static/media/NEPZA.883e52f2.jpg";